// src/theme/hooks.js
import { useMemo } from 'react';
import theme from './theme';

/**
 * Hook to create component styles using the theme
 * @param {Function} stylesFn - Function that takes theme and returns styles
 * @returns {Object} Memoized styles
 */
export const useStyles = (stylesFn) => {
  return useMemo(() => {
    if (typeof stylesFn !== 'function') {
      console.warn('useStyles expects a function that takes theme as an argument');
      return stylesFn;
    }
    return stylesFn(theme);
  }, [stylesFn]);
};

/**
 * Hook to get theme values
 * @returns {Object} Theme object
 */
export const useTheme = () => {
  return theme;
};

/**
 * Hook to create dynamic styles based on props
 * @param {Function} stylesFn - Function that takes props and theme and returns styles
 * @returns {Function} Function that takes props and returns styles
 */
export const createStyles = (stylesFn) => {
  return (props) => {
    return stylesFn(props, theme);
  };
};
